import * as React from 'react';
import { useAnalytics, TrackActionArgs } from '@withjoy/web-core';
import { MobileMarketingNav, MarketingSiteNav } from './components';
import { getMarketingEnv } from '../../../../../utils/getJoyEnv';
interface MarketingNavProps {
  navType: 'mobile' | 'desktop';
  mobileNavOpen: boolean;
  handleMobileNavClose: (event: React.MouseEvent<HTMLMainElement, MouseEvent>) => void;
  handleMobileNavOpen: (event: React.MouseEvent<HTMLMainElement, MouseEvent>) => void;
}

export enum MarketingNavKey {
  features = 'features',
  designs = 'designs',
  pricing = 'pricing',
  faq = 'faq',
  sample = 'sample',
  help = 'help'
}

enum FeatureNavKey {
  weddingWebsite = 'wedding-website',
  guestList = 'guest-list',
  app = 'app',
  saveTheDate = 'save-the-date',
  weddingInvites = 'wedding-invitations',
  registry = 'registry'
}
export type MarketingNavItem = {
  key: MarketingNavKey;
  text: string;
  url: string;
  track: TrackActionArgs;
};

export type FeatureNavItem = {
  key: FeatureNavKey;
  text: string;
  url: string;
  icon: string;
  track: TrackActionArgs;
};

const marketingEnv = getMarketingEnv(window.joyEnv);

export const MarketingNav: React.SFC<MarketingNavProps> = ({ children, navType, ...props }) => {
  const analytics = useAnalytics({
    category: 'Designs',
    page: 'landing',
    pagePrefix: 'marketing',
    deferPageTrack: true
  });

  const marketingNavItems: MarketingNavItem[] = [
    {
      key: MarketingNavKey.features,
      text: 'Features',
      url: 'https://withjoy.com/features',
      track: {
        action: 'Toggle',
        label: 'features'
      }
    },
    {
      key: MarketingNavKey.designs,
      text: 'Designs',
      url: 'https://withjoy.com/designs',
      track: {
        action: 'WWWNavigate',
        label: 'menu2designs'
      }
    },
    {
      key: MarketingNavKey.pricing,
      text: 'Pricing',
      url: 'https://withjoy.com/pricing',
      track: {
        action: 'WWWNavigate',
        label: 'menu2pricing'
      }
    },
    {
      key: MarketingNavKey.faq,
      text: 'Faq',
      url: 'https://withjoy.com/faq',
      track: {
        action: 'WWWNavigate',
        label: 'menu2faq'
      }
    },
    {
      key: MarketingNavKey.sample,
      text: 'Sample',
      url: 'https://withjoy.com/demo',
      track: {
        action: 'WWWNavigate',
        label: 'menu2demo'
      }
    },
    {
      key: MarketingNavKey.help,
      text: 'Help',
      url: 'https://help.withjoy.com',
      track: {
        action: 'WWWNavigate',
        label: 'menu2help'
      }
    }
  ];

  const featureNavItems: FeatureNavItem[] = [
    {
      key: FeatureNavKey.weddingWebsite,
      text: 'Wedding Website',
      url: `${marketingEnv}/wedding-website`,
      icon: 'https://withjoy.com/assets/public/www/icon-website.svg',
      track: {
        action: 'WWWNavigate',
        label: 'features-website'
      }
    },
    {
      key: FeatureNavKey.guestList,
      text: 'Guest List',
      url: `${marketingEnv}/guest-list`,
      icon: 'https://withjoy.com/assets/public/www/icon-guest-list.svg',
      track: {
        action: 'WWWNavigate',
        label: 'feature-guest-list'
      }
    },
    {
      key: FeatureNavKey.saveTheDate,
      text: 'Save the Dates',
      url: `${marketingEnv}/save-the-date`,
      icon: 'https://withjoy.com/assets/public/www/icon-save-the-date.svg',
      track: {
        action: 'WWWNavigate',
        label: 'features-save-the-date'
      }
    },
    {
      key: FeatureNavKey.weddingInvites,
      text: 'Invites & RSVP',
      url: `${marketingEnv}/wedding-invitations`,
      icon: 'https://withjoy.com/assets/public/www/icon-rsvp.svg',
      track: {
        action: 'WWWNavigate',
        label: 'features-invites-rsvp'
      }
    },
    {
      key: FeatureNavKey.registry,
      text: 'Registry',
      url: `${marketingEnv}/registry`,
      icon: 'https://withjoy.com/assets/public/www/icon-registry.svg',
      track: {
        action: 'WWWNavigate',
        label: 'feature-registry'
      }
    },
    {
      key: FeatureNavKey.app,
      text: 'Mobile App',
      url: `${marketingEnv}/app`,
      icon: 'https://withjoy.com/assets/public/www/icon-app.svg',
      track: {
        action: 'WWWNavigate',
        label: 'feature-app'
      }
    }
  ];

  if (navType === 'mobile') {
    return (
      <MobileMarketingNav
        analytics={analytics}
        featureNavItems={featureNavItems}
        marketingNavItems={marketingNavItems}
        mobileNavOpen={props.mobileNavOpen}
        handleMobileNavClose={props.handleMobileNavClose}
        handleMobileNavOpen={props.handleMobileNavOpen}
      />
    );
  } else {
    return (
      <MarketingSiteNav
        analytics={analytics}
        featureNavItems={featureNavItems}
        marketingNavItems={marketingNavItems}
        mobileNavOpen={props.mobileNavOpen}
        handleMobileNavClose={props.handleMobileNavClose}
        handleMobileNavOpen={props.handleMobileNavOpen}
      />
    );
  }
};
